import { useTranslation } from 'react-i18next';

import { AutosizeChipInput } from './AutosizeChipInput';
import { getEmptyChipHint } from './utils/getEmptyChipHint';

type Props = {
    label: string;
    onChange: (next: string) => void;
    value: string;
};

export const PositionalChip = ({ label, onChange, value }: Props) => {
    const { t } = useTranslation();
    const hint = value ? undefined : getEmptyChipHint(t, label, undefined);

    return (
        <AutosizeChipInput
            ariaLabel={label}
            value={value}
            placeholder={hint?.text}
            placeholderVariant={hint?.variant}
            onChange={onChange}
        />
    );
};
